import CustomerNav from './CustomerNav';
import CustomerContainer from './CustomerContainer';
import Footer from '../ui/Footer';
import React from 'react';

export default function CustomerView({children}) {
  return (
    <>
      <CustomerNav/>
      <CustomerContainer>
        {children}
      </CustomerContainer>
      <Footer>
        <p>Disclaimer: This website is a demo and does not sell any product or service for purchase.</p>
        <p>Copyright 2021 Zach Samuels</p>
        <a href="https://www.pexels.com">Photos provided by Pexels</a>
      </Footer>
    </>
  )
}